import { GraphQlClient, Http } from '@intelipost-js/secure-providers';
import { ScToast } from '@intelipost-js/secure-components';

export default {
  getMicroStateWithoutId({ commit }) {
    return GraphQlClient.query(`
      query {
        getMicroStateWithoutId {
          id,
          code,
          name,
        }
      }`)
      .then((res) => {
        const {
          data = {},
        } = res || {};
        const {
          getMicroStateWithoutId = [],
        } = data || {};
        commit('toggleLoading', false);
        commit('setMicroStatus', getMicroStateWithoutId);
        return Promise.resolve(res);
      })
      .catch((err) => {
        commit('toggleLoading', false);
        return Promise.reject(err);
      });
  },
  getLogisticProviders({ commit }, active = false) {
    commit('toggleLoading', true);

    return GraphQlClient.query(`
    query($active: Boolean) {
      logisticProviders(active: $active) {
        id
        name
        delivery_methods {
          id
          name
          logo_url
          enabled
          pending_contracts
          type
        }
      }
    }`, { active })
      .then(({ data = {} }) => {
        commit('toggleLoading', false);
        const { logisticProviders = [] } = data;

        commit('setLogisticProviders', logisticProviders);
        return Promise.resolve(logisticProviders);
      })
      .catch((err) => {
        commit('toggleLoading', false);
        return Promise.reject(err);
      });
  },
  sendRemoveOrder({ commit }, params) {
    commit('toggleLoading', true);

    const {
      createdDate,
      searchType,
      macro_status,
      micro_status,
      orderNumber,
      delivery_methods } = params;

    const { start, end } = createdDate;

    return GraphQlClient.mutation(`
    mutation (
      $volume_state_id: Int,
      $delivery_method_id: Int,
      $start_date: Date,
      $end_date: Date,
      $micro_state_id: Int,
      $order_numbers: [String],
      $search_type: String,
    ) {
      removeOrderSend(
        volume_state_id: $volume_state_id
        delivery_method_id: $delivery_method_id
        start_date: $start_date
        end_date: $end_date
        micro_state_id: $micro_state_id
        order_numbers: $order_numbers
        search_type: $search_type
      ) {
          shipment_order_number
          state_id
          state_name
          micro_state_id
          micro_state_description
          esprinter_message
          event_date
          delivery_method_id
          id
        }
      }
    `, {
      delivery_method_id: delivery_methods,
      order_numbers: orderNumber,
      volume_state_id: macro_status,
      micro_state_id: micro_status,
      start_date: start,
      end_date: end,
      search_type: searchType,
    })
    .then(({ data }) => {
      const { removeOrderSend = [] } = data;

      if (removeOrderSend.length > 0) {
        commit('setListOrders', removeOrderSend);
      } else {
        ScToast.danger('Nenhum evento localizado');
      }
      commit('toggleLoading', false);
      return removeOrderSend;
    })
    .catch((err) => {
      commit('toggleLoading', false);
      return Promise.reject(err);
    });
  },
  deleteOrder({ commit }, params) {
    commit('toggleLoading', true);

    const orderNumbers = [];
    const historyIds = [];

    params.map((res) => {
      orderNumbers.push(res.shipment_order_number);
      historyIds.push(res.id);
      return {
        orderNumbers,
        historyIds };
    });

    const body = {
      order_numbers: orderNumbers,
      delivery_method_id: params[0].delivery_method_id,
      volume_state_id: params[0].state_id,
      micro_state: params[0].micro_state_id,
      history_ids: historyIds,
    };

    return Http.post('api/v1/shipment_order_volume_history/histories/delete', body)
      .then(() => {
        ScToast.success('Eventos excluídos com sucesso');
        commit('toggleLoading', false);
      })
      .catch((err) => {
        commit('toggleLoading', false);
        return Promise.reject(err);
      });
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-order/features/order-remove/store/actions.js